<template>
<v-card>
    <v-card-text>

      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <ValidationProvider
            rules="required"
            vid="subject"
            :name="$t('fields.mail_subject').toLowerCase()"
            v-slot="{ errors }"
        >
            <v-text-field
                v-model=" form.subject"
                :counter="255"
                :label="$t('fields.mail_subject')"
                :error-messages="errors"
            ></v-text-field>

        </ValidationProvider>

        <ValidationProvider
            rules="required"
            vid="body"
            :name="$t('fields.body').toLowerCase()"
            v-slot="{ errors }"
        >
          <ckeditor :editor="editor" v-model="form.body" :config="editorConfig"></ckeditor>
        </ValidationProvider>
        <v-row>
        <v-col
          cols="9"
        >
          <ValidationProvider>
            <vue2Dropzone
              class="mt-5"
              v-on:vdropzone-success="addFile"
              v-on:vdropzone-sending="sendingEvent"
              v-on:vdropzone-removed-file="removeFile"
              :options="dropzoneOptions">
            </vue2Dropzone>
          </ValidationProvider>
        </v-col>

        <v-col
          cols="3"
          v-if="getExistingFile.length"
        >
          <v-list
            class="files-list"
            dense
            :height="200"
          >
            <v-subheader>{{ $t('FILES') }}</v-subheader>
            <v-list-item-group
              color="primary"
            >
              <v-list-item
                v-for="(item) in getExistingFile"
                :key="item.file_id"
              >
                <v-list-item-icon>
                  <v-btn
                    v-if="can('communication_manager')"
                    icon
                    color="red"
                    @click="downloadFile(item.file_id, item.fullname)"
                  >
                    <v-icon>file_download</v-icon>
                  </v-btn>

                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.fullname"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    v-if="can('communication_manager')"
                    icon
                    color="red"
                    @click="deleteExistingFile(item.file_id)"
                  >
                    <v-icon>cancel</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
        </v-row>


    </ValidationObserver>

    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn :to="{name: routeName.COMMUNICATION }">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapActions } from 'vuex';


  import vue2Dropzone from 'vue2-dropzone';
  import 'vue2-dropzone/dist/vue2Dropzone.min.css';
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import { communicationsService } from '../../utils/services/communications.service';
  import { routeNames } from '../../config/router/routeNames';
  import api from '../../utils/services/api.service';
  import { filesService } from '../../utils/services/files.service';
  import { uploader } from '../../config/ckeditor/uploader';

  export default {
    name: 'CommunicationNew',
    components: {
      vue2Dropzone,
    },
    props: {
      id: {
        type: String,
      },
    },
    data() {
      return {

        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [uploader],
        },
        attachments: [],
        form: {
          id: 0,
          subject: null,
          body: null,
          attachments: [],
          force_delete: [],
        },
        communication: {},
        loading: false,
        dropzoneOptions: {
          url: `${api.getApiUrl()}/files`,
          thumbnailWidth: 200,
          addRemoveLinks: true,
          headers: { Authorization: localStorage.getItem('auth-token') },
        },
      };
    },

    computed: {
      getAttachments() {
        return this.attachments.map(x => x.id);
      },
      getExistingFile() {
        return Object.keys(this.communication).length
        ? this.communication.attachments.filter(x => this.form.force_delete.indexOf(x.file_id) === -1)
        : [];
      },
    },

    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),

      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            this.form.attachments = this.getAttachments.concat(
              this.getExistingFile.map(x => x.file_id),
            );
            communicationsService.save(this.form)
            .then(() => {
              this.$router.push({ name: routeNames.COMMUNICATION });
            })
            .catch(error => {
                this.handleError(error, this.errors);
            });
        }
      },
      sendingEvent(file, XMLHttpRequest, formData) {
        formData.append('name', file.name);
      },

      addFile(file, response) {
        this.attachments.push({
          id: response.file.id,
          uuid: file.upload.uuid,
        });
      },

      removeFile(file) {
        const index = this.attachments.map(x => x.uuid).indexOf(file.upload.uuid);
        if (index > -1) {
          this.attachments.splice(index, 1);
        }
      },

      deleteExistingFile(fileId) {
        this.showConfirm({
            onConfirm: () => {
              this.form.force_delete.push(fileId);
            },
        });
      },

      downloadFile(fileId, filename) {
        this.loading = true;
        return filesService.download(fileId)
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
        })
        .catch((error) => {

        })
        .finally(() => {
          this.loading = false;
        });
      },

      fetchCommunication() {
        return communicationsService.get(this.id)
        .then(response => {
          this.communication = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
      },
    },
    async created() {
      if (this.id) {
        await this.fetchCommunication();
        this.form.id = this.communication.id;
        this.form.subject = this.communication.subject;
        this.form.body = this.communication.body;
      }
    },
  };
</script>

<style>
  .ck-editor__editable {
    min-height: 500px;
   }

   .files-list{
    height:200px;
    overflow-y:auto
  }

</style>
